import Page from '../../components/Page';
import { observer } from 'mobx-react-lite';
import { Route, Switch } from 'react-router-dom';
import Webhooks from './Webhooks';
import Webhook from './Webhook';
import NewWebhook from './NewWebhook';
import Deliveries from './Deliveries';
import Paths from '../../constants/paths';
import ErrorMessages from '../../components/ErrorMessages.js/index.js';

const WebhooksTab = ({ store }) => {
    return (
        <Page loading={!store.dataLoaded}>
            <div style={{ marginLeft: '2.5%' }}>
                <ErrorMessages messages={store.error} />
            </div>
            <Switch>
                <Route exact path={Paths.NEW_WEBHOOK}>
                    <NewWebhook store={store} />
                </Route>
                <Route exact path={Paths.WEBHOOK_DELIVERIES}>
                    <Deliveries store={store} />
                </Route>
                <Route exact path={Paths.WEBHOOK}>
                    <Webhook store={store} />
                </Route>
                <Route exact path={Paths.WEBHOOKS}>
                    <Webhooks store={store} />
                </Route>
            </Switch>
        </Page>
    );
};

export default observer(WebhooksTab);
